import Vue from 'vue'
import Router from 'vue-router'
import Registration from './views/Registration.vue'
import ParticipantsPublic from "./views/ParticipantsPublic";
import CertificatePublic from "./views/CertificatePublic.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/certificate/:uuid',
      name: 'certificate',
      component: CertificatePublic
    },
    {
      path: '/:token',
      name: 'registration',
      component: Registration
    },
    {
      path: '/:token/participants/:password',
      name: 'participants-public',
      component: ParticipantsPublic
    },
  ]
})
